export const ROUTES = {
    home: "/",
    projects: "/projects",
    about: "/about",
    contact: "/contact",
}